<div id="collection-access-dialog" class="dialog">
    <div class="dialog-title">
      <h2>{{ 'collection.dialog.share'|translate }}</h2>
       <button mat-icon-button (click)="close()">
           <mat-icon  fontIcon="close"></mat-icon>
       </button>

    </div>
    <mat-dialog-content>
        @if (state === 'init') {
            <section id="collection-share-init">
                <div class="share-option">
                    <div class="row">
                        <div class="col-12">
                            <div class="option-wrapper">
                                <mat-icon fontIcon="person"></mat-icon>
                                <div class="txt">
                                    <h3>{{'collection.share.access' |translate}}</h3>
                                    <p> {{ 'collection.share.user.description'|translate }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="btn-row">
                                <div></div>
                                <button mat-raised-button (click)="state = 'access'">
                                    <span>{{ 'collection.action.addaccess'|translate }}</span>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="share-option">
                    <div class="row">
                        <div class="col-12">
                            <div class="option-wrapper">
                                <mat-icon fontIcon="share"></mat-icon>
                                <div class="txt">
                                    <h3> {{ 'collection.share.link'|translate }}</h3>
                                    <p>{{'shareLink.description' | translate}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="btn-row">
                                <div></div>
                                <button mat-raised-button (click)="state = 'link'">
                                    <span>
                                        @if (collection.sharedLink) {
                                            {{ 'collection.action.editlink'|translate }}
                                        } @else {
                                            {{ 'collection.action.createlink'|translate }}
                                        }
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                    <div class="share-option">
                        <div class="row">
                            <div class="col-12">
                                <div class="option-wrapper">
                                    <mat-icon fontIcon="language"></mat-icon>
                                    <div class="txt">
                                        <h3> {{ 'collection.share.publication'|translate }}</h3>
                                        <p>{{'publicLink.description' | translate}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="btn-row">
                                    <div></div>
                                    <button mat-raised-button (click)="state = 'publication'">
                                        @if(!collection.publication) {
                                            <span>{{ 'collection.action.makepublic'|translate }}</span>
                                        } @else {
                                            <span>{{ 'collection.action.editpublic'|translate }}</span>
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
            </section>
        } @else if (state === 'access') {
            <app-collection-share-access [collection]="collection" (back)="state = 'init'"
                                         (collectionChange)="handleCollectionChange($event)"></app-collection-share-access>
        } @else if (state === 'link') {
            <app-collection-share-link [collection]="collection" (back)="state = 'init'"
                                       (collectionChange)="handleCollectionChange($event)"></app-collection-share-link>
        } @else if (state === 'publication') {
            <app-collection-share-publication [collection]="collection" (back)="state = 'init'"
                                              (collectionChange)="handleCollectionChange($event)"></app-collection-share-publication>
        }
    </mat-dialog-content>
</div>
